module.exports = __webpack_public_path__ + "static/media/about2.748786ea.jpg";